module.exports = __webpack_public_path__ + "a04c7f22db7d35c129251dc07d5f760f.pdf";